export default class WhatsappBlockModel {
  numeroWhatsapp!: string;

  idContato?: number;

  motivo?: string;

  status!: number;
}
